import styled from 'styled-components'
import { InputForm, breakpoints, media } from '../../../../assets/styles'
import { colors } from 'app-v2/design-systems/theme/colors'
import { Text } from '../../../../common/typography'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { BORDER, SPACING } from '../../../../../app-v2/design-tokens'

export const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    ${media.large`
            width: 100%;
            max-width: 886px;
            margin: ${SPACING.L} 0;
            padding: 56px 56px 36px 236px;
            gap: ${SPACING.L};
    `}
    flex-direction: column;
    padding: ${SPACING.L};
    border-radius: ${BORDER.RADIUS.XL};
    background-color: ${colors.white};
    gap: ${SPACING.S};
    position: relative;
`
export const StyledBagAnimation = styled.img`
    flex: none;
    z-index: 2;
    height: 208px;
    ${media.large`
        height: 272px;
        position: absolute;
        background: ${colors.white};
        border: ${BORDER.WIDTH.XS} solid ${colors.darkMayo};
        border-radius: ${BORDER.RADIUS.L};
        left: -56px;
        transform: rotate(-4deg);
    `}
`
export const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${media.medium`align-items: start;`}
`
export const StyledInput = styled.input``

export const ErrorMessage = styled.p`
    padding: 4px 12px;
    color: ${colors.fieryRed};
    font-size: 12px;
    line-height: 1.33;
    font-family: ${fonts.flameSansRegular};
    margin-bottom: 0;
    ${props => (props.error ? `display: block;` : `display: none;`)}
    ${props => !props.error && media.medium`display: none;`}
    ${props => !props.error && media.large`visibility: hidden; display: block;`}
`

export const StyledInputForm = styled(InputForm)`
    margin-top: 0;
    position: relative;
    ${StyledInput} {
        margin-top: 0;
        height: 50px;
        ${props =>
            props.error &&
            `
        color: ${colors.fieryRed};
        border: 1px solid ${colors.fieryRed};`}
        ${props => (props.paddingRight ? 'padding-right: 50px;' : '')}
    }
`

export const StyledText = styled(Text)`
    font-family: ${fonts.flameRegular};
    padding: 0 24px;
    text-align: center;
    ${media.large`
        font-size: 24px;
        line-height: 1.5;
        padding: 0;
        text-align: left
    `}
`
export const StyledCodeEnteringContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${SPACING.XS};
    width: 100%;
    margin-top: ${SPACING.M};
    box-sizing: border-box;
`

export const StyledForm = styled.form`
    width: 100%;
`
export const StyledFormContainer = styled.div`
    width: 100%;

    @media (max-width: ${breakpoints.large}px) {
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding-top: ${SPACING.L};
        border-radius: ${BORDER.RADIUS.XL};
        background-color: ${colors.white};
    }
`
